// extracted by mini-css-extract-plugin
export default {"photoPost":"UserPhotoPost_photoPost__4G4Cm","imgInput":"UserPhotoPost_imgInput__UDAQm","preview":"UserPhotoPost_preview__1xlh3"};